import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'
const AddDeviceComponent = LanguageStrings().DeviceManagementCollectionStrings.AddDeviceComponent

// Define schemas using Zod
const ZGroupDetails = z.object({
  groupName: z.string(),
  distributionList: z.array(z.string()),
  siteDetails: z.record(z.string()),
  severityDetails: z.record(z.string())
})

const ZGroupDetailsResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZGroupDetails.nullable()
})

// Export types derived from Zod schemas
export type GroupDetails = z.infer<typeof ZGroupDetails>
export type GroupDetailsResponse = z.infer<typeof ZGroupDetails>

export async function getEmailGroupDetails (
  groupId: string,
  onSuccess: (groupDetails: GroupDetailsResponse, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): Promise<void> {
  const url = `/communications-service/api/v1/udp/tiq/services/email/view-group/${groupId}`
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      console.log('Response from getEmailGroupDetails:', response)
      const parseResponse = ZGroupDetailsResponse.safeParse(response.data)
      if (parseResponse.success) {
        if (parseResponse.data.data !== null && parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        } else {
          onFailure(parseResponse.data.error, parseResponse.data.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure(AddDeviceComponent.NetworkError, error.status)
      }
    })
}
